import React from 'react';

import { useHistory } from 'react-router';

import { css } from '@emotion/css';
import { TenantUserPermission } from '@recurrency/core-api-schema/dist/common/enums';
import { Typography } from 'antd';

import { Button } from 'components/Button';
import { FlexSpace } from 'components/FlexSpace';

import { useGlobalApp } from 'hooks/useGlobalApp';

import { routes } from 'utils/routes';

import DailyWorkflowAllItemsReviewedIcon from 'assets/svgs/daily-workflow-all-items-reviewed.svg';
import DailyWorkflowAllItemsSubmittedIcon from 'assets/svgs/daily-workflow-all-items-submitted.svg';

export function DailyWorkflowFinishedState({
  type = 'reviewed',
  onPressSendReviews,
  secondaryButton,
}: {
  type: 'reviewed' | 'submitted';
  onPressSendReviews?: () => void;
  secondaryButton?: React.ReactNode;
}) {
  const { activeTenant } = useGlobalApp();
  const history = useHistory();
  return (
    <FlexSpace
      direction="column"
      alignItems="center"
      justify="center"
      className={css`
        flex: 1;
        margin: auto;
      `}
    >
      {type === 'submitted' ? (
        <>
          <DailyWorkflowAllItemsSubmittedIcon />
          <Typography.Title
            className={css`
              margin-top: 50px;
            `}
            level={2}
          >
            Congrats, you've finished your daily workflow!
          </Typography.Title>
          <FlexSpace gap={10}>
            <Button type="default" onClick={() => history.push(routes.demandPlanning.planning())}>
              Go to Planning
            </Button>
            {secondaryButton}
          </FlexSpace>
        </>
      ) : (
        <>
          <DailyWorkflowAllItemsReviewedIcon />
          <Typography.Title
            className={css`
              margin-top: 50px;
            `}
            level={2}
          >
            All items reviewed, ready to send to ERP
          </Typography.Title>
          {onPressSendReviews && (
            <Button
              type="primary"
              permissionsRequired={[
                TenantUserPermission.ActionExportMinMax,
                TenantUserPermission.ActionEditItemSupplierDetails,
              ]}
              onClick={onPressSendReviews}
            >
              Send Reviews to {activeTenant?.erpType.toUpperCase()}
            </Button>
          )}
        </>
      )}
    </FlexSpace>
  );
}
